import React, { useEffect } from 'react';
import {
  Navigate,
  useLocation,
} from 'react-router-dom';
import { type Location, type Params, type NavigateFunction } from 'react-router-dom';

import auth from '@/apis/auth';
import { setPrefilledProcessId } from '@/actions/common/commonPure';
import { AppDispatch } from '@/index';
import { useDispatch } from 'react-redux';


export type ProtectedRouteProps = {
    children: any;
    router: {
      location: Location;
      navigate: NavigateFunction;
      params: Params;
    };
  }
  
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, router }) => {
  const {params: {processId}} = router;

  const { instance:{ customername }} = window;
  const isLoggedIn = auth.loggedIn();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if(processId){
      dispatch(setPrefilledProcessId(processId));
    }
  }, [processId]);
  
  if (!isLoggedIn) {
    return <Navigate to={`/${customername}login`} replace state={{ from: location }} />;
  }
  
  return <>{children}</>;
};